export default {
  SET_TEMPLATE_DATA(state, payload) {
    state.template = payload
  },
}
